import { Box } from '@material-ui/core'
import { ArticleAttributes } from 'components/facets/ArticleAttributes'
import { RarityBadge } from 'components/facets/RarityBadge'
import { useUser } from 'components/providers/UserProvider'
import { getPriceFormat } from 'lib/utils'
import { OrderArticle } from 'shared'
import { getProductImageUrl } from 'utils/imageUtils'
import { PickingButton } from './PickingButton'
import { locationBeforePick } from './PickingPresenter'

export interface SingleImagePickingProps {
  article: OrderArticle
  handlePick?: (article: OrderArticle) => void
  handleCompletePicking?: (article: OrderArticle, readonly: boolean) => void
  handleReportIssue?: (a: OrderArticle) => void
}

export const SingleImagePicking = ({
  article,
  handleCompletePicking,
  handleReportIssue,
}: SingleImagePickingProps): JSX.Element => {
  const { user } = useUser()
  const showAvailableQuantity = user.showAvailableQuantityInPickingLocations ?? false
  const imgSrc = getProductImageUrl(article.idProduct)

  return (
    <div className="container">
      {article ? (
        <>
          <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start">
            <img className="single-image-picking-img" src={imgSrc} />
            <div className="d-flex flex-column justify-content-start w-100 mt-3 mt-md-0 ms-md-3">
              <h3 className="fw-bold text-break">{article.getLocalizedName()}</h3>
              {article.getLocalizedName() !== article.card.name && (
                <h6 className="m-0 p-0 mb-3">[{article.card.name}]</h6>
              )}
              <div className="d-flex flex-wrap align-items-start w-100">
                <h5 className="pe-1">#{article.card.cn}</h5>
                <h5>{article.card.expansion}</h5>
              </div>
              {article.card?.rarityStr && (
                <div className="d-flex flex-row mb-2">
                  <Box width={32} className="me-1">
                    <RarityBadge
                      rarity={article.card.rarityStr ?? ''}
                      idGame={article.card!.idGame!}
                      className="ms-1"
                    />
                  </Box>
                  <h5 className="m-0 p-0">{article.card?.rarityStr}</h5>
                </div>
              )}
              <h5 className="single-image-picking-price fs-5">
                {getPriceFormat(article.price, article.currencyCode)}
              </h5>
              <span className="mt-3 fs-6">Properties:</span>
              {/* quantity, attributes */}

              <ArticleAttributes article={article} iconHeight={21} />
              <div className="d-flex flex-row flex-wrap mt-2 align-items-end">
                <span className="me-1 fs-6 text-nowrap">Order bin:</span>{' '}
                <span className="fs-5 fw-bold"> {article.pickingId}</span>
              </div>
              <div className="d-flex flex-row flex-wrap mt-2 align-items-end">
                <span className="me-1 fs-6 text-nowrap">Qty to pick:</span>{' '}
                <div className="d-flex flex-row fs-5 fw-bold">
                  <span>{locationBeforePick(article, showAvailableQuantity)}</span>
                </div>
              </div>
              <div className="d-flex flex-row flex-wrap mt-2 align-items-end">
                <span className="me-1 fs-6 text-nowrap">Comment:</span>{' '}
                <span className="fs-5"> {article.comment}</span>
              </div>
              <div className="d-flex flex-row mt-4">
                <div className="me-2">
                  <PickingButton
                    type="pick"
                    article={article}
                    handleCompletePicking={() => handleCompletePicking!(article, false)}
                    fullWidth
                  />
                </div>
                <PickingButton
                  type="reportIssue"
                  article={article}
                  handleReportIssue={handleReportIssue}
                  fullWidth
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>
          <h6>No more articles to pick</h6>
        </div>
      )}
    </div>
  )
}
